import React, { useState, useEffect } from 'react';
import { MenuItem, TextField, Grid } from '@mui/material';

function Select({ options = [], column, id, label = null, onChange = null, value = '', disabled = false, ...otherProps }) {
  const [inputValue, setInputValue] = useState(value);

  const handleInputChange = (e) => {
    setInputValue(e.target.value);
    if (typeof onChange === 'function') onChange(e);
  };

  useEffect(() => {
    setInputValue(value);
  }, [value]);

  return (
    <Grid size={column ? Number(column) : 6}>
      <span>{label}</span>
      <TextField select id={id} variant="outlined" fullWidth size="small" onChange={handleInputChange} value={inputValue} disabled={disabled} {...otherProps}>
        {options.map((option) => (
          <MenuItem key={option.value || option.title} value={option.value}>
            {option.title || option.label}
          </MenuItem>
        ))}
      </TextField>
    </Grid>
  );
}

export default Select;
